import { createContext, useContext, useReducer } from 'react';
import { blogReducer, initialState, BlogState } from './services/blog.reducer';

export const BlogStateContext = createContext({} as BlogState);
export const blogActionContext = createContext({} as any);

interface Props {
    children: React.ReactNode;
}

export default function BlogProvider({ children }: Props) {
    const [state, reducer] = useReducer(blogReducer, initialState);

    return (
        <blogActionContext.Provider value={reducer}>
            <BlogStateContext.Provider value={state}>{children}</BlogStateContext.Provider>
        </blogActionContext.Provider>
    );
}

export const useBlogState = () => {
    const state = useContext(BlogStateContext);
    if (!state) {
        throw new Error('you should use context inside provider');
    }

    return state;
};

export const useBlogAction = () => {
    const action = useContext(blogActionContext);
    if (!action) {
        throw new Error('you should use context inside provider');
    }

    return action;
};

